export const USER_ROLES = {
    STUDENT: "Student",
    TUTOR: "Tutor",
    ADMIN: "Admin",
    SUPERADMIN: "Superadmin",
    SUPERVISER: "Superviser",
};